import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import ModuleForm from "../Layouts/ModuleForm";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import { ModuleFormValues } from "src/models/Module.model";
import {
  useGetModuleByIdQuery,
  useUpdateModuleByIdMutation,
} from "src/services/ModuleService";

type Props = {
  onClose: () => void;
  selectedModuleId: string;
};

const EditModuleWrapper = ({ onClose, selectedModuleId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetModuleByIdQuery(selectedModuleId);
  const [updateModuleById] = useUpdateModuleByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);
  const initialValues: ModuleFormValues = {
    moduleName: items?.moduleName || "",
    order: items?.order || "",
  };
  // Validation Schema
  const validationSchema = object().shape({
    moduleName: string().required("Please enter Module name"),
    order: string().required("Please enter order"),
  });

  // Handle Submit
  const handleSubmit = (
    values: ModuleFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ModuleFormValues>
  ) => {
    const payload = {
      moduleName: values.moduleName,
      order: Number(values.order),
    };
    updateModuleById({ id: selectedModuleId, body: payload }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <ModuleForm
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditModuleWrapper;
